<div style="visibility: hidden;" class="card overflow-auto md:mr-6 fx-col--lt-md fx-row--gt-sm">
  <div class="bg-primary text-primary-contrast p-gutter fx-flex-auto--lt-md fx-flex-300px--gt-sm">
    <h2 class="headline mb-4">Mega Menu</h2>

    <p class="caption">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there
      live the blind
    texts.</p>

    <p class="caption">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language
    ocean.</p>

    <button class="border border-primary-contrast border-solid mt-4" mat-button type="button">LEARN MORE</button>
  </div>

  <div class="p-gutter fx-flex-auto--lt-md fx-flex-400px--gt-sm">
    <h3 class="body-2 m-0">FEATURES</h3>

    <div class="mt-4 gd-cols-1fr-1fr-1fr gd-gap-16px">
      @for (feature of features; track feature) {
        <a (click)="close()"
          [routerLink]="feature.route"
          class="text-dark p-3 text-center hover:bg-hover hover:text-primary trans-ease-out rounded block no-underline">
          <iconify-icon [attr.icon]="feature.icon" width="32" height="32" class="text-primary"></iconify-icon>
          <div class="body-1 mt-2">{{ feature.label }}</div>
        </a>
      }
    </div>
  </div>

  <div class="p-gutter fx-flex-auto--lt-md fx-flex-350px--gt-sm">
    <h3 class="body-2 m-0">PAGES</h3>

    <div class="mt-6 gd-cols-1fr-1fr gd-gap-16px-48px">
      @for (page of pages; track page) {
        <a (click)="close()"
          [routerLink]="page.route"
        class="text-dark body-1 no-underline hover:text-primary trans-ease-out">{{ page.label }}</a>
      }
    </div>
  </div>
</div>

